import { Modal, Tabs, Timeline } from "antd";
import { useContext } from "react";
import { EditableContext } from "../../common/EditableContextProvider";
import { CheckCircleOutlined } from '@ant-design/icons';
import { TablePasos } from "../../admin/casos/TablePasos";

export const ModalPasosTitular = () => {
    const { casos } = useContext(EditableContext);

    const PasosView = () => {
        return (
            <div className="col-md border-start">
                <div className="mb-3">
                    <p className="h4">Estado del caso</p>
                </div>
                <div className="p-2">
                    <Timeline
                        items={casos.editItem.pasos.map(ps => {
                            if (ps.estado === 'REALIZADO') {
                                return {
                                    children: (<span className="fw-bold">{ps.descripcion}. (REALIZADO)</span>),
                                    color: 'green',
                                    dot: (<CheckCircleOutlined style={{ fontSize: '18px' }} />)
                                };
                            }
                            return {
                                children: ps.descripcion,
                                color: 'gray'
                            };

                        })}
                    />
                </div>
            </div>
        );
    }

    return (
        <Modal
            open={casos.visibleForm}
            onCancel={casos.closeForm}
            destroyOnClose={true}
            footer={null}
            width={900}
        >
            <Tabs
                items={[
                    { label: "Pasos", key: "pasosview", children: (<PasosView />) },
                    { label: "Tabla", key: "tablepasos", children: (<TablePasos />) },
                ]}
            ></Tabs>
        </Modal>

    );
}